import { getParamKey } from '../../_data/getParamKey';
import { QuestionMethods } from '../questionMethods.types';
import {
	RenderedMatrixQuestion,
	MatrixGivenAnswer,
} from './matrixMethods.types';

export const addMatrixToSearchParams: QuestionMethods<
	RenderedMatrixQuestion,
	MatrixGivenAnswer
>['addToSearchParams'] = ({ searchParamsDraft, question, givenAnswers }) => {
	const matrixAnswers = givenAnswers.matrix.get(question.id);

	if (matrixAnswers != null) {
		const paramKey = getParamKey(question.id);
		if (matrixAnswers.rows.length === 0) {
			searchParamsDraft.set(paramKey, '');
		} else {
			for (const row of question.rows) {
				const answerForRow = matrixAnswers.rows.find(
					(rowData) => rowData.rowId === row.id,
				)?.columnId;
				searchParamsDraft.append(paramKey, `${row.id}-${answerForRow}`);
			}
		}
	}
};

export const addMatrixToGivenAnswers: QuestionMethods<
	RenderedMatrixQuestion,
	MatrixGivenAnswer
>['addToGivenAnswers'] = ({ givenAnswersDraft, searchParams, question }) => {
	const matrixAnswers = searchParams.getAll(getParamKey(question.id));

	if (matrixAnswers.length > 0) {
		if (matrixAnswers.length === 1 && matrixAnswers[0] === '') {
			givenAnswersDraft.matrix.set(question.id, { rows: [] });
		}
		givenAnswersDraft.matrix.set(question.id, {
			rows: matrixAnswers.map((answer) => {
				const [rowId, columnId] = answer.split('-') || [];

				return {
					rowId: rowId,
					columnId: columnId || question.columns[0].id, // If no value given, then use first answer
				};
			}),
		});
	}
};
